import React, { useState, useEffect } from 'react';
import config from '../config/siteConfig.json';

const CountdownTimer = ({ targetDate, targetTime, textColor }) => {
  const { boda } = config;
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  // Color por defecto o personalizado
  const color = textColor || '#FFFFFF';

  useEffect(() => {
    const calculateTimeLeft = () => {
      // Usar props si se proporcionan, sino usar config
      const fecha = targetDate || boda.fechaBoda;
      const hora = targetTime || boda.horaCeremoniaCivil;
      const weddingDate = new Date(`${fecha}T${hora}:00`);
      const now = new Date();
      const difference = weddingDate - now;

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60)
        });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, [targetDate, targetTime, boda.fechaBoda, boda.horaCeremoniaCivil]);

  const TimeBox = ({ value, label }) => (
    <div className="flex flex-col items-center">
      <div 
        className="relative bg-white/10 backdrop-blur-md rounded-xl p-3 md:p-6 shadow-2xl min-w-[60px] md:min-w-[120px]"
        style={{ border: '2px solid rgba(255,255,255,0.2)' }}
      >
        <div 
          className="text-2xl md:text-5xl font-bold"
          style={{ 
            fontFamily: 'Playfair Display',
            textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
            color: color
          }}
        >
          {String(value).padStart(2, '0')}
        </div>
      </div>
      <p 
        className="mt-2 md:mt-3 text-xs md:text-base uppercase tracking-wider"
        style={{ 
          fontFamily: 'Cormorant Garamond',
          textShadow: '1px 1px 2px rgba(0,0,0,0.5)',
          color: color
        }}
      >
        {label}
      </p>
    </div>
  );

  return (
    <div className="my-12 animate-fade-in-delay-2">
      <h3 
        className="text-2xl md:text-3xl mb-8 text-center"
        style={{
          fontFamily: 'Playfair Display',
          textShadow: '2px 2px 4px rgba(0,0,0,0.6)',
          color: color
        }}
      >
        Faltan
      </h3>
      <div className="flex justify-center gap-2 md:gap-8">
        <TimeBox value={timeLeft.days} label="Días" />
        <TimeBox value={timeLeft.hours} label="Horas" />
        <TimeBox value={timeLeft.minutes} label="Minutos" />
        <TimeBox value={timeLeft.seconds} label="Segundos" />
      </div>
    </div>
  );
};

export default CountdownTimer;
